export default __webpack_public_path__ + "static/default-image-49f80ae9438b8c6b9f2642699b09e5f5.png";